import { IMessageEditItem, MessageEditItem } from "./messageEditItem";
import { IEventEdit } from "../event/eventEdit";
import { IFileAttachment, FileAttachment } from "ui/Scripts/source/models/common/fileAttachment";

export interface IMessageEdit {
    item: IMessageEditItem;
    attachments: IFileAttachment[];
}

export class MessageEdit implements IMessageEdit {
    item: MessageEditItem;
    attachments: FileAttachment[];

    constructor();
    constructor(obj: IEventEdit);
    constructor(obj?: any) {
        this.item = null;
        if (obj && obj.item) {
            this.item = new MessageEditItem(obj.item);
        }
        this.attachments = [];
        if (obj && obj.attachments) {
            for (let i = 0; i < obj.attachments.length; i++) {
                this.attachments.push(new FileAttachment(obj.attachments[i]));
            }
        }
    }
}